import { musicProductPhysicalCopyrights } from "components/organisms/forms/music-product-physical/MusicProductPhysicalForm";
import { RELEASE_TYPE } from "services/music-product-digital/types/enums";
import { IMusicProductPhysicalForm } from "services/music-product-physical/types/form";
import { IMusicProductPhysicalResponse } from "services/music-product-physical/types/query";
import { settlementInfoQueryToForm } from "./settlementInfoQueryToForm";
import { convertTracksToAlbumsForm } from "./tracksToAlbums";

export const convertMusicProductPhysicalQueryToForm = (
  musicProductPhysicalQuery: IMusicProductPhysicalResponse
): IMusicProductPhysicalForm => {
  const { id, ...musicProductPhysicalForm } = {
    ...musicProductPhysicalQuery,
    releaseDate: musicProductPhysicalQuery.releaseDate
      ? new Date(musicProductPhysicalQuery.releaseDate)
          .toISOString()
          .slice(0, 10)
      : "",
    tracks: convertTracksToAlbumsForm(musicProductPhysicalQuery.tracks),
    artists: musicProductPhysicalQuery.artists.map((artist) => ({
      id: artist.artistId,
      role: artist.artistRole,
      nickname: artist.nickname,
            artistStatus: artist.artistStatus,
      previewPicture: artist.previewPicture,
      isDuplicated: artist.isDuplicated,
      watchListArtist: artist.watchListArtist,
    })),
    cLine: musicProductPhysicalQuery.cLine ?? musicProductPhysicalCopyrights,
    pLine: musicProductPhysicalQuery.pLine ?? musicProductPhysicalCopyrights,
    releaseType: musicProductPhysicalQuery.releaseType ?? RELEASE_TYPE.unknown,
    genre:
      musicProductPhysicalQuery.genre !== null &&
      musicProductPhysicalQuery.genre.id !== -1
        ? {
            id: musicProductPhysicalQuery.genre.id,
            name: musicProductPhysicalQuery.genre.name,
          }
        : { id: -1, name: "" },
    settlementInfo: settlementInfoQueryToForm(
      musicProductPhysicalQuery.settlementInfo
    ),
    deliveryFilter: { onlyDefaultProviders: true },
  };
  return musicProductPhysicalForm;
};
